

export  default {
    //list转成父子结构
    listToTree(list,pid,pidName,idName) {
        let ret = [];//一个存放结果的临时数组
        for(let i in list) {
            if(list[i][pidName] === pid) {//如果当前项的父id等于要查找的父id，进行递归
                list[i].children = this.listToTree(list, list[i][idName],pidName,idName);
                ret.push(list[i]);//把当前项保存到临时数组中
            }
        }
        return ret;//递归结束后返回结果
    },
    //格式化后台传过来的秒数 转化为年月日
    formatDate:function(str){
        let oDate = new Date(str),
            oYear = oDate.getFullYear(),
            oMonth = oDate.getMonth()+1,
            oDay = oDate.getDate();
        return oYear +'-'+ this.addZero(oMonth) +'-'+ this.addZero(oDay) +'';
    },
    formDataToHms(str){
        let oDate = new Date(str),
            oYear = oDate.getFullYear(),
            oMonth = oDate.getMonth()+1,
            oDay = oDate.getDate(),
            oHour = oDate.getHours(),
            oMinute = oDate.getMinutes(),
            oSecond = oDate.getSeconds();
        return oYear +'-'+ this.addZero(oMonth) +'-'+ this.addZero(oDay) +' ' + this.addZero(oHour)+":"+this.addZero(oMinute)+":"+this.addZero(oSecond);
    },
    //格式化秒数为时分秒转化为json对象供highCharts组件
    dateToHour(value){
        let secondTime = parseInt(value),minuteTime = 0,hourTime = 0;
        if(secondTime > 60) {
            minuteTime = parseInt(secondTime / 60);
            secondTime = parseInt(secondTime % 60);
            if(minuteTime > 60) {
                hourTime = parseInt(minuteTime / 60);
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        return {hour:hourTime,minute:minuteTime,second:secondTime};
    },

    addZero(num){
        if(parseInt(num) < 10){
            num = '0'+num;
        }
        return num;
    },


    clearAllCookie() {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        for (const cookie of cookies) {
            const [name] = cookie.split('=');
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;${process.env.VUE_APP_DOMAIN?('domain='+process.env.VUE_APP_DOMAIN):''}`;
        }
    },
     setExpiresCookie(name, value, timestamp) {
         const expires = new Date(timestamp); // 将时间戳转换为毫秒
         expires.setTime(expires.getTime() + (8 * 60 * 60 * 1000));
         document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;${process.env.VUE_APP_DOMAIN?('domain='+process.env.VUE_APP_DOMAIN):''}`;
    },

     setCookie(name, value) {
         document.cookie = `${name}=${value};expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;${process.env.VUE_APP_DOMAIN?('domain='+process.env.VUE_APP_DOMAIN):''}`;
     },
    getCookie(cookieName) {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        for (const cookie of cookies) {
            const [name, value] = cookie.split('=');
            if (name === cookieName) {
                return decodeURIComponent(value);
            }
        }
        return null; // 如果没有找到指定的 cookie
    },



    //删除字符串中的p标签
    deletePTag(val){
        if(val){
            return val.replace(new RegExp(/<\/?p\/?>/g), "");
        }else{
            return val
        }
    },

}
